// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialogWrapper .dialogForm-dialogForm .el-form-item__label{width:110px;font-size:12px;font-weight:400}.dialogWrapper .el-dialog__title{font-size:14px}.dialogWrapper .el-dialog{width:25%}", ""]);
// Exports
module.exports = exports;
